import { classnames } from '@aibees/shared/utils';
import { Button, Stack, Typography } from '@mui/material';
import { memo, useState } from 'react';
import { useChangeTracker } from '../../context/change-tracker';
import * as Styled from './styles';
import * as SX from './sx';
import type { AccountSeatsProps as Props } from './types';

export const AccountSeats = memo(({ className }: Props) => {
  const [seats, setSeats] = useState(3);
  const { markDirty } = useChangeTracker();

  const increase = () =>
    setSeats((prev) => {
      const next = Math.min(prev + 1, 20);
      if (next !== prev) markDirty();
      return next;
    });

  const decrease = () =>
    setSeats((prev) => {
      const next = Math.max(prev - 1, 1);
      if (next !== prev) markDirty();
      return next;
    });

  return (
    <Styled.Wrapper
      className={classnames('AccountSeats', className)}
      sx={SX.root}
      gap={0.5}
    >
      <Typography variant="body4" color="grey.500">
        Account seats (Maximum 20)
      </Typography>
      <Stack direction="row" alignItems="center" spacing={2}>
        <Button onClick={decrease} size="small" variant="outlined">
          -
        </Button>

        <Typography variant="body2" color="grey.700" fontWeight={600}>
          {seats}
        </Typography>
        <Button onClick={increase} size="small" variant="outlined">
          +
        </Button>
      </Stack>
    </Styled.Wrapper>
  );
});

AccountSeats.displayName = 'AccountSeats';
